import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, Typography } from "@mui/material";
import { JustInfo } from "../../../utils/Icon";

const RuleItem = ({ label, info }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        minHeight: 32,
      }}
    >
      <CheckCircleOutlineIcon
        color='success'
        sx={{ fontSize: 18, flexShrink: 0 }}
      />

      <Typography variant='body2' fontWeight={600} sx={{ lineHeight: 1.5 }}>
        {label}
      </Typography>

      {info && <JustInfo title={info} />}
    </Box>
  );
};

export default RuleItem;
